import { forwardRef, useCallback, useRef } from 'react';
import { NQTRadioButtonProps } from './models';
import './NQTRadioButton.scss';

export const NQTRadioButton = forwardRef((
  {checked, id, label, name, radioClassContainer,  value, updateHandler}: NQTRadioButtonProps,
  ref: React.ForwardedRef<HTMLSpanElement|null>
):JSX.Element => {
  NQTRadioButton.displayName = 'NQTRadioButton';

  const radioButton = useRef<HTMLSpanElement|null>(null);

  const onClickHandler = useCallback((ref) => {
    const castedRef = ref as React.MutableRefObject<HTMLSpanElement | null>;
    if (castedRef?.current) {
      castedRef.current.focus();
    } else {
      radioButton.current && radioButton.current.focus();
    }
  }, []);

  return (
    <label htmlFor={id} className={`nqt-input-radio-container ${radioClassContainer ? radioClassContainer : ''}`}>
      <input className='d-none'
        type="radio"
        id={id}
        name={name}
        checked={checked}
        onClick={() => onClickHandler(ref)}
        onChange={(e) => updateHandler(e.currentTarget.value)}
        value={value}/>
      <span tabIndex={0}
        id={`${id}-anchor`}
        ref={ref}
        aria-checked={checked}
        role="radio"
        className="nqt-input-radio"
        onKeyUp={(e) => (e.key === ' ' || e.key === 'Enter') && updateHandler(value)}>
      </span>
      <span className="nqt-input-radio-label ps-1">{!!label && label}</span>
    </label>
  );
});